import { z } from 'zod'

/**
 * O alcance da linha-guia da mesa, em metros de mesa.
 *
 * Um NÚMERO e não um enum de modos, porque a diferença entre "sem mira", "a
 * mira de hoje" e "mira estendida" é só quanto da trajetória prevista a tela
 * desenha. Com o alcance como campo, os três são presets e uma mesa
 * customizada não precisa de campo nenhum a mais.
 *
 *    0   sem mira: a tela não desenha nada da previsão
 *   -1   infinito: desenha tudo, até as bolas pararem
 *  > 0   o limite: corta os traços depois do contato nesse alcance
 *
 * `-1` é o ÚNICO negativo aceito. Qualquer outro é erro de quem chamou, não
 * "um pouco de infinito" — aceitar `-2` em silêncio esconderia o bug até
 * aparecer como traço invisível numa mesa valendo SOL.
 *
 * O teto de 20 não é gosto, é guarda: a diagonal da mesa tem 2,2 m, e um
 * `1e9` faria o desenho percorrer a mesa um milhão de vezes.
 *
 * MÓDULO PRÓPRIO, e não dentro do `index`: a sala (no `index`) e o evento de
 * mesa (em `eventos-de-mesa`) usam os dois o mesmo alcance, e o `index` já
 * importa os eventos. Deixar a definição no `index` fechava um ciclo —
 * `MiraM` chegava aos eventos antes de existir, e o parse morria com
 * "Cannot access 'MiraM' before initialization". Aqui embaixo não há ciclo.
 */
export const MIRA_INFINITA = -1
export const MIRA_PADRAO_M = 0.34
export const MIRA_TETO_M = 20

export const MiraM = z
  .number()
  .finite()
  .refine((v) => v === MIRA_INFINITA || (v >= 0 && v <= MIRA_TETO_M), {
    message: `miraM: use ${MIRA_INFINITA} para infinito, ou de 0 a ${MIRA_TETO_M}`,
  })
